export const SUPPLIERS_BASE_URL = '/kode/v1/suppliers';
